import { render, staticRenderFns } from "./RateButton.vue?vue&type=template&id=1d1ff957&scoped=true"
import script from "./RateButton.vue?vue&type=script&lang=js"
export * from "./RateButton.vue?vue&type=script&lang=js"
import style0 from "./RateButton.vue?vue&type=style&index=0&id=1d1ff957&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1ff957",
  null
  
)

export default component.exports